// extracted by mini-css-extract-plugin
export var container = "_8g-0";
export var containerTopRight = "_8g-1";